import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Car as CarIcon } from "lucide-react";
import { carTitle, formatKm, formatPrice, photoUrl } from "../lib/company";
import { tv, useT } from "../lib/i18n";

export const CarPhoto = ({ path, alt, className = "" }) =>
  path ? (
    <img src={photoUrl(path)} alt={alt} loading="lazy" className={`w-full h-full object-cover ${className}`} />
  ) : (
    <div className="w-full h-full grid place-items-center bg-[#E9E6DE] text-[var(--muted)]"><CarIcon className="w-12 h-12" strokeWidth={1.2} /></div>
  );

export const CarCard = ({ car, index = 0 }) => {
  const t = useT();
  const title = carTitle(car, t.card.fallback);
  const specs = [car.anno, car.km != null ? formatKm(car.km) : null, tv(t, car.carburante), tv(t, car.cambio)].filter(Boolean);
  return (
    <motion.div initial={{ opacity: 0.001, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}>
      <Link to={`/auto/${car.id}`} data-testid={`car-card-${car.id}`} className="group block">
        <div className="relative aspect-[4/3] overflow-hidden rounded-[22px] bg-[var(--ink)]">
          <div className="w-full h-full transition-transform duration-[1.2s] ease-[cubic-bezier(.16,1,.3,1)] group-hover:scale-[1.06]">
            <CarPhoto path={car.foto?.[0]} alt={title} />
          </div>
          {car.venduto && (
            <span className="absolute top-4 left-4 rounded-full bg-[var(--red)] text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5">{t.card.sold}</span>
          )}
          {car.foto?.length > 1 && (
            <span className="absolute top-4 right-4 rounded-full bg-black/55 backdrop-blur text-white font-mono text-[11px] px-2.5 py-1">{car.foto.length} {t.card.photos}</span>
          )}
          <span className="absolute bottom-4 right-4 grid place-items-center w-12 h-12 rounded-full bg-white text-[var(--ink)] translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[opacity,transform] duration-500">
            <ArrowUpRight className="w-5 h-5" />
          </span>
        </div>
        <div className="pt-5 flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h3 className="font-display text-xl md:text-2xl font-semibold tracking-tight truncate group-hover:text-[var(--red)] transition-colors">{title}</h3>
            {specs.length > 0 && <p className="mt-1.5 text-sm text-[var(--muted)]">{specs.join(" · ")}</p>}
          </div>
          <p className="font-display text-xl md:text-2xl font-semibold whitespace-nowrap" data-testid={`car-price-${car.id}`}>{formatPrice(car.prezzo)}</p>
        </div>
      </Link>
    </motion.div>
  );
};
